import React, { createContext, useEffect, useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import SplashScreen from 'src/components/SplashScreen';
import axios from 'axios';
import { gql, useMutation, useQuery } from '@apollo/client';

const initialAuthState = {
  isAuthenticated: false,
  isInitialised: false,
  user: {
    _id: '',
    fname: '',
    lname: '',
    email: '',
    role: '',
    status: '',
    created_at: '',
    updated_at: ''
  }
};

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
  } else {
    localStorage.removeItem('accessToken');
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INITIALISE': {
      const { isAuthenticated, user } = action.payload;
      return {
        ...state,
        isAuthenticated,
        isInitialised: true,
        user
      };
    }
    case 'LOGIN': {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        isInitialised: true,
        user
      };
    }
    case 'LOGOUT': {
      return {
        ...state,
        isAuthenticated: false,
        user: null
      };
    }
    case 'REGISTER': {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        user
      };
    }
    default: {
      return { ...state };
    }
  }
};

const AuthContext = createContext({
  ...initialAuthState,
  method: 'JWT',
  login: () => Promise.resolve(),
  logout: () => {},
  register: () => Promise.resolve()
});

const LOGIN = gql`
  mutation LoginAdmin($input: UserLogIn) {
    loginAdmin(input: $input) {
      accessToken
      userAccount {
        _id
        fname
        lname
        email
        role
        status
        created_at
        updated_at
      }
    }
  }
`;

const ME = gql`
  query {
    me {
      _id
      fname
      lname
      email
      role
      status
      created_at
      updated_at
    }
  }
`;

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialAuthState);

  const history = useHistory();
  const [loginAdmin] = useMutation(LOGIN);
  const { loading, error, data } = useQuery(ME);

  // const accessToken = window.localStorage.getItem('accessToken');
  // const { loading, error, data } = useQuery(ME);
  // if (!loading) {
  //   console.log(data);
  // }

  const login = async (email, password) => {
    const res = await loginAdmin({ variables: { input: { mobile: email, password } } });
    const data = res.data.loginAdmin;
    const { accessToken, userAccount } = data;

    setSession(accessToken);
    dispatch({
      type: 'LOGIN',
      payload: {
        user: userAccount
      }
    });
  };

  const logout = () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  };

  const register = async (email, firstName, password) => {
    const response = await axios.post('/api/users', {
      email,
      firstName,
      password
    });

    if (response.status === 201) {
      // window.location.href = '/login';
      history.push('/login');
    }
    // const { accessToken, user } = response.data;

    // window.localStorage.setItem('accessToken', accessToken);

    // dispatch({
    //   type: 'REGISTER',
    //   payload: {
    //     user
    //   }
    // });
  };

  useEffect(() => {
    if (loading == false && error == null && data) {
      dispatch({
        type: 'INITIALISE',
        payload: {
          isAuthenticated: true,
          user: data.me
        }
      });
    } else if (loading == false && error) {
      dispatch({
        type: 'INITIALISE',
        payload: {
          isAuthenticated: false,
          user: null
        }
      });
    }
  }, [loading, error, data]);

  if (!state.isInitialised) {
    return <SplashScreen />;
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'JWT',
        login,
        logout,
        register
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
